/**
 * In-memory storage stub for chat (messages per slide) and notes (text per slide/user).
 * Replace with Firestore when config has firebaseConfig.
 */

import type { ChatMessage } from '../core/types';

const chatByKey = new Map<string, ChatMessage[]>();
const notesByKey = new Map<string, { text: string }>();

function chatKey(presId: string, slideIndex: number): string {
  return presId + '|' + slideIndex;
}
function notesKey(presId: string, slideIndex: number, uid: string): string {
  return presId + '|' + slideIndex + '|' + uid;
}

export const chatStorage = {
  getMessages(presId: string, slideIndex: number): ChatMessage[] {
    return chatByKey.get(chatKey(presId, slideIndex)) || [];
  },
  async addMessage(presId: string, slideIndex: number, msg: Partial<ChatMessage>): Promise<string | undefined> {
    const key = chatKey(presId, slideIndex);
    const list = chatByKey.get(key) || [];
    const id = 'm' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    list.push({ ...msg, id, text: msg.text ?? '', createdAt: Date.now() } as ChatMessage & { createdAt: number });
    chatByKey.set(key, list);
    return id;
  },
  deleteMessage(presId: string, slideIndex: number, msgId: string): ChatMessage[] {
    const key = chatKey(presId, slideIndex);
    const list = chatByKey.get(key) || [];
    const next = list.filter((m) => m.id !== msgId);
    chatByKey.set(key, next);
    return next;
  }
};

export const notesStorage = {
  getNote(presId: string, slideIndex: number, uid: string): { text: string } {
    return notesByKey.get(notesKey(presId, slideIndex, uid)) || { text: '' };
  },
  setNote(presId: string, slideIndex: number, uid: string, data: { text: string }): void {
    notesByKey.set(notesKey(presId, slideIndex, uid), { text: data.text || '' });
  }
};
